module.exports = __webpack_public_path__ + "img/phone.96dd4a7e.svg";